/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TumorBoardReferral from './tumor-board-referral';
import TumorBoardReferralDetail from './tumor-board-referral-detail';
import TumorBoardReferralUpdate from './tumor-board-referral-update';
import TumorBoardReferralDeleteDialog from './tumor-board-referral-delete-dialog';

const TumorBoardReferralRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TumorBoardReferral />} />
    <Route path="new" element={<TumorBoardReferralUpdate />} />
    <Route path=":id">
      <Route index element={<TumorBoardReferralDetail />} />
      <Route path="edit" element={<TumorBoardReferralUpdate />} />
      <Route path="delete" element={<TumorBoardReferralDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TumorBoardReferralRoutes;
